import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function MSExcelIcon({ className, fill, height, width }: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      height={height ?? 24}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 24}
    >
      <g fill={fill ?? IconColors.Green} fillRule="evenodd">
        <path d="M6.5 10.73l-.804-2.009c-.153-.384-.59-.571-.975-.417-.384.153-.571.59-.417.975l1.388 3.471-1.388 3.471c-.154.385.033.822.417.975.385.154.822-.033.975-.417l.804-2.01.804 2.01c.153.384.59.571.975.417.384-.153.571-.59.417-.975L7.308 12.75l1.388-3.471c.154-.385-.033-.822-.417-.975-.385-.154-.822.033-.975.417l-.804 2.01zm15.125 10.207c0 .76-.616 1.375-1.375 1.375H3.75c-.76 0-1.375-.615-1.375-1.375V3.063c0-.759.616-1.374 1.375-1.374h13.791c.36 0 .704.14.96.39l2.709 2.643c.265.259.415.614.415.984v15.233zM10.022 9.002v6c0 1.243 1.007 2.25 2.25 2.25h1.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.5c-.414 0-.75-.336-.75-.75v-6c0-.414-.336-.75-.75-.75s-.75.336-.75.75zm8.965-.75h-1.5c-1.242 0-2.25 1.007-2.25 2.25 0 1.25.499 1.874 1.8 2.85.949.711 1.2 1.026 1.2 1.65 0 .414-.335.75-.75.75h-1.5c-.414 0-.75.336-.75.75s.336.75.75.75h1.5c1.243 0 2.25-1.007 2.25-2.25 0-1.25-.498-1.874-1.8-2.85-.948-.711-1.2-1.026-1.2-1.65 0-.414.336-.75.75-.75h1.5c.415 0 .75-.336.75-.75s-.335-.75-.75-.75z" />
      </g>
    </SimpleIcon>
  );
}
